import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { WindowMU } from "app/types/WindowMU"

declare var window:WindowMU

export async function definirPrecoTintaItem(params: {
    identificadorItem:number
    preco: number
}) {

    const orcamento = store.getState().orcamento

    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPrecoTintaItem(orcamento.IdentificadorOrcamento,params.identificadorItem,params.preco)

    store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
    window.orcamentoController.model.atualizar(
        orcamentoAtualizado,
        true,
        true,
        true
    )
}